'use strict';

export default angular
  .module('maestro.filters.C2F', [])

  .filter('C2F', function() {
    return function(value) {
      return ((Number(value) * 1.8) + 32).toFixed(0);
    };
  })

  .name;
